import { Chip, Divider, Grid } from "@mui/material";
import React from "react";
import styles from "../../../../customer/styles/customerStyles.module.css";

export default function PersonalInfo({ user }) {
  return (
    <div style={{ padding: "15px" }}>
      <div style={{ width: "45%" }} className="flexbox">
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <div>
              <strong>First Name</strong>
              <h6 style={{ marginTop: "10px" }}> {user?.first_name}</h6>
            </div>
          </Grid>
          <Grid item xs={6}>
            <div>
              <strong>Last Name</strong>
              <h6 style={{ marginTop: "10px" }}> {user?.last_name}</h6>
            </div>
          </Grid>
          <Grid item xs={6}>
            <div>
              <strong>Email</strong>
              <h6 style={{ marginTop: "10px" }}> {user?.email}</h6>
            </div>
          </Grid>
          <Grid item xs={6}>
            <div>
              <strong>Phone</strong>
              <h6 style={{ marginTop: "10px" }}>
                {" "}
                {user?.phone || "Not available"}
              </h6>
            </div>
          </Grid>
          <Grid item xs={6}>
            <div>
              <strong>Role</strong>
              <h6 style={{ marginTop: "10px" }}> {user?.role}</h6>
            </div>
          </Grid>
          <Grid item xs={6}>
            <div
              style={{
                background: user?.isVerified ? "#D4FFD3" : "#FFCFCF",
                maxWidth: "100px",
                textAlign: "left",
              }}
              className={styles.fulfillment}
            >
              {user?.isVerified ? "Active" : "Inactive"}
            </div>
          </Grid>
          <Grid item xs={12}>
            <Divider sx={{ marginBottom: "20px" }} />
            <strong style={{ fontSize: "16px" }}>Questionnaires</strong>
            {user?.questionnaires?.length > 0 ? (
              <Grid container sx={{ marginTop: "10px" }}>
                {user?.questionnaires?.map((item) => (
                  <Grid item xs={6}>
                    <strong>{item?.question}</strong>
                    {Array.isArray(item?.answer) ? (
                     item?.answer?.map((ans) => <Chip
                     label={ans}
                     variant="filled"
                     style={{ marginRight: "5px", marginTop:"5px" }}
                   />) 
                    ) : (
                      <h6 style={{ marginTop: "10px" }}>
                        {" "}
                        {item?.answer}
                      </h6>
                    )}

                    {/* <h6 style={{ marginTop: "10px" }}> {item?.answer +","}</h6> */}
                  </Grid>
                ))}
              </Grid>
            ) : (
              <h6>No questionnaires found</h6>
            )}
          </Grid>
        </Grid>
        <div></div>
      </div>
    </div>
  );
}
